import { __assign } from 'tslib';
import React__default from 'react';
import { Box, ToggleButton } from '@mui/material';
import clsx from 'clsx';
import Tag from '../../Dataview/Tags/Tag/index.js';
import DefaultIcon from '../../DefaultIcon/index.js';

var FieldTags = function (_a) {
    var tags = _a.tags, enabledTagIdValues = _a.enabledTagIdValues, onChange = _a.onChange, id = _a.id, sx = _a.sx, className = _a.className, _b = _a.testId, testId = _b === void 0 ? "FieldTags" : _b, _c = _a.KIcon, KIcon = _c === void 0 ? DefaultIcon : _c;
    return (React__default.createElement(Box, { className: clsx("FieldTags", className), id: id, "data-testid": testId, sx: __assign({ display: "flex", flexDirection: "column" }, sx) }, tags.map(function (tag, index) {
        var _a;
        if (tag.id === undefined) {
            return React__default.createElement(React__default.Fragment, null);
        }
        var selected = enabledTagIdValues === null || enabledTagIdValues === void 0 ? void 0 : enabledTagIdValues.includes(tag.id);
        var backgroundColor = tag.backgroundColor;
        return (React__default.createElement(ToggleButton, { key: "tag-button-".concat(index), "data-testid": "".concat(testId, "-ToggleButton-").concat(tag.id), value: tag.id, selected: selected !== null && selected !== void 0 ? selected : false, onClick: function () {
                onChange({
                    tagId: tag.id,
                    enabled: !selected
                });
            }, size: "small", sx: {
                border: "none",
                display: "flex",
                marginTop: "5px",
                borderRadius: "5px",
                color: tag.textColor,
                backgroundColor: backgroundColor,
                ":hover": {
                    backgroundColor: backgroundColor
                },
                padding: "4px",
                textTransform: "inherit",
                justifyContent: "flex-start",
                "&.MuiToggleButton-root.Mui-selected": {
                    color: tag.textColor,
                    backgroundColor: backgroundColor,
                    ":hover": {
                        backgroundColor: backgroundColor
                    }
                }
            } },
            (enabledTagIdValues === null || enabledTagIdValues === void 0 ? void 0 : enabledTagIdValues.includes(tag.id)) && (React__default.createElement(KIcon, { className: "fa-solid fa-square-check" })),
            !(enabledTagIdValues === null || enabledTagIdValues === void 0 ? void 0 : enabledTagIdValues.includes(tag.id)) && React__default.createElement(KIcon, { className: "fa-regular fa-square" }),
            React__default.createElement(Tag, { marginTop: 0, marginBottom: 0, marginLeft: 0, key: "tag-label-".concat(index), title: (_a = tag.name) !== null && _a !== void 0 ? _a : "", textColor: tag.textColor, backgroundColor: backgroundColor, configurationMode: true })));
    })));
};

export { FieldTags as default };
//# sourceMappingURL=index.js.map
